/* global Browser */

import {standardListener, eventTypes} from '../config/vars';
//import {elHTML} from '../config/vars';
import {triggerEvent} from '../lib/helper';
import {currentBreakpoint} from '../lib/responsive';

const triggerSelector = '.accordion-trigger';
const contentSelector = '.accordion-content';
const afterClass = 'after-prepare';

export default class Accordion {

  constructor(el) {

    this.el = el;

    this.group = el.getAttribute('data-group');
    this.autoOpenBreakpoints = JSON.parse(el.getAttribute('data-autoopen') || '[]');
    this.contentHeight = 0;
    this.isOpen = this.el.classList.contains('is-active');
    this.needsOverflow = this.el.classList.contains('has-overflowing-content');
    this.resizeTimer;
    this.oldWinWidth = window.innerWidth;
    this.actualWinWidth = this.oldWinWidth;
    this.toggleHandler = this.toggle.bind(this);

    this.triggerArr = [].slice.call(this.el.querySelectorAll(triggerSelector));
    this.content = this.el.querySelector(contentSelector);

    // TODO: Don't we need the review as well?
    if (Browser.isSafari && !this.el.classList.contains('review') && this.content) {

      this.safariHelperHandler = this.safariHelper.bind(this);

      eventTypes['transitionEnd'].map(transitionEndEvent => {

        this.content.addEventListener(transitionEndEvent, this.safariHelperHandler);

      });
    }

    this.triggerArr.forEach(elem => {

      elem.addEventListener(standardListener, this.toggleHandler, false);
    });

    if ( this.group ) {

      this.handleGroup();
    }

    if ( this.autoOpenBreakpoints === true || this.autoOpenBreakpoints.indexOf(currentBreakpoint) != -1) {

      this.open(false);
    }
  }

  removeStandardEvents() {

    this.triggerArr.forEach(elem => {

      elem.removeEventListener(standardListener, this.toggleHandler, false);
    });
  }

  safariHelper(e) {

    if (this.isOpen && e.propertyName === 'height') {

      this.content.style.transition = 'none';

      this.resetHeight();
    }
  }

  handleGroup() {

    document.addEventListener('accordion-open', e => {

      if (!this.isOpen) {

        return;
      }

      let collapse = e.data.collapse;

      if ( this === collapse || this.group !== collapse.group ) {

        return;
      }

      this.close(false);
    });
  }

  calculateHeight() {

    let oldHeight = this.content.style.height || '0';

    if (!this.isOpen) {

      this.content.classList.add(afterClass);

      this.resetHeight();
    }

    this.contentHeight = this.content.offsetHeight;

    this.content.style.height = oldHeight;
  }

  setHeight(height) {

    this.content.style.height = height + 'px';
    //this.content.style.minHeight = height + 'px';
  }

  resetHeight() {

    this.content.style.height = 'auto';
    //this.content.style.minHeight = 'auto';
    setTimeout(()=>{

      this.content.style.transition = '';
    }, 1);
  }

  open(trigger = true) {

    if (this.isOpen) {

      return;
    }

    this.calculateHeight();
    // debugger;
    // TODO: replace setTimeout with RAF version
    setTimeout(() => {

      this.setHeight(this.contentHeight);
      this.isOpen = true;
    }, 100);

    if ( !Browser.isSafari ) {

      setTimeout(() => {


        this.resetHeight();
      }, 500);
    }

    if ( this.needsOverflow ) {


      setTimeout(() => {

        this.el.classList.add('opening-transition-enden');
      }, 500);
    }

    this.el.classList.add('is-active');

    trigger && this.dispatchEvent('open');
  }

  close(trigger = true) {

    if ( !this.isOpen ) {

      return;
    }

    // TODO: Does it rly make sense??? why set it again?
    this.calculateHeight();
    this.setHeight(this.contentHeight);

    this.el.classList.remove('opening-transition-enden');

    // TODO: Y THO?????
    setTimeout(() => {

      this.setHeight(0);

    }, 100);

    this.isOpen = false;
    this.el.classList.remove('is-active');

    trigger && this.dispatchEvent('close');
  }

  toggle(e) {

    e.preventDefault();

    this[this.isOpen ? 'close' : 'open']();
  }

  dispatchEvent(type) {

    triggerEvent(this.el, 'accordion-' + type, {collapse: this});
  }
};
